import { render } from "./StatsWidgetRenderer.vue?vue&type=template&id=223abea6&scoped=true"
import script from "./StatsWidgetRenderer.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetRenderer.vue?vue&type=script&lang=ts"

import "./StatsWidgetRenderer.vue?vue&type=style&index=0&id=223abea6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-223abea6"

export default script